import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { FullPageCard } from "component/shared/full-page-card";
import { styles } from "./styles";
import {
	settingsWidgets,
	settingsListingResults,
	settingsMapSearch,
	settingsLocationCustomization,
	settingsIdx,
	supportCenter,
	markets,
} from "routes/paths";
import { User } from "model/user";
import * as Icon from "react-feather";
import { RouterLinkWrapper } from "component/shared/router-link-wrapper";
import * as env from "shared/env";

interface Props extends WithStyles<typeof styles> {
	user: User;
}

class Component extends React.Component<Props> {
	public render() {
		const { classes = {}, user } = this.props;
		return (
			<FullPageCard>
				<Mui.Grid
					container
					direction="column"
					alignItems="center"
					spacing={3}
					className={classes.body}
				>
					<Mui.Grid item>
						<Mui.Typography>
							Welcome to your iHomefinder Control Panel. This is where you manage your
							iHomefinder account, including your listings and leads, as well as how
							property search and results appear on your website.
						</Mui.Typography>
						<Mui.Typography style={{ marginTop: 16 }}>
							Use the following links to learn more about essential topics:
						</Mui.Typography>
						<ul style={{ marginBottom: 0, marginTop: 8, paddingLeft: 24 }}>
							<li>
								<Mui.Link
									href="https://kb.ihomefinder.com/s/article/iHomefinder-for-Wix#LiveMLSData"
									target="_blank"
									rel="noopener"
								>
									Connecting live MLS data
								</Mui.Link>
							</li>
							<li>
								<Mui.Link
									href="https://kb.ihomefinder.com/s/article/iHomefinder-for-Wix#CreatedContent"
									target="_blank"
									rel="noopener"
								>
									Pages installed with the Wix App
								</Mui.Link>
							</li>
							<li>
								<Mui.Link
									href="https://kb.ihomefinder.com/s/article/iHomefinder-for-Wix#Widgets"
									target="_blank"
									rel="noopener"
								>
									Widgets available with the Wix App
								</Mui.Link>
							</li>
							<li>
								<Mui.Link
									href="https://kb.ihomefinder.com/s/article/iHomefinder-for-Wix#iHomefinderControlPanel"
									target="_blank"
									rel="noopener"
								>
									iHomefinder Control Panel Basics
								</Mui.Link>
							</li>
						</ul>
					</Mui.Grid>
					<Mui.Grid item>
						<Mui.Typography className={classes.boldText}>
							WIX Website Shortcuts
						</Mui.Typography>
					</Mui.Grid>
					<Mui.Grid item>
						<Mui.Typography>
							Follow the links below to configure your account for display on your Wix
							site.
						</Mui.Typography>
					</Mui.Grid>
					<Mui.Grid item>
						<Mui.Button
							to={markets}
							component={RouterLinkWrapper}
							color={"primary"}
							variant="outlined"
							className={classes.button}
						>
							<Mui.Grid container direction="column" alignItems="center">
								<Icon.MapPin fontSize="large" />
								<Mui.Typography className={classes.typography} variant="button">
									Create Markets
								</Mui.Typography>
							</Mui.Grid>
						</Mui.Button>
						<Mui.Button
							to={settingsListingResults}
							component={RouterLinkWrapper}
							color={"primary"}
							variant="outlined"
							className={classes.button}
						>
							<Mui.Grid container direction="column" alignItems="center">
								<Icon.Home fontSize="large" />
								<Mui.Typography className={classes.typography} variant="button">
									Listing Settings
								</Mui.Typography>
							</Mui.Grid>
						</Mui.Button>
						<Mui.Button
							to={
								user.permissions.eurekaSearch
									? settingsMapSearch
									: settingsLocationCustomization
							}
							component={RouterLinkWrapper}
							color={"primary"}
							variant="outlined"
							className={classes.button}
						>
							<Mui.Grid container direction="column" alignItems="center">
								<Icon.Search fontSize="large" />
								<Mui.Typography className={classes.typography} variant="button">
									Search Settings
								</Mui.Typography>
							</Mui.Grid>
						</Mui.Button>
						<Mui.Button
							to={settingsIdx}
							component={RouterLinkWrapper}
							color={"primary"}
							variant="outlined"
							className={classes.button}
						>
							<Mui.Grid container direction="column" alignItems="center">
								<Icon.Layout fontSize="large" />
								<Mui.Typography className={classes.typography} variant="button">
									Site Settings
								</Mui.Typography>
							</Mui.Grid>
						</Mui.Button>
						<Mui.Button
							to={supportCenter}
							component={RouterLinkWrapper}
							color={"primary"}
							variant="outlined"
							className={classes.button}
						>
							<Mui.Grid container direction="column" alignItems="center">
								<Icon.HelpCircle fontSize="large" />
								<Mui.Typography className={classes.typography} variant="button">
									Support Center
								</Mui.Typography>
							</Mui.Grid>
						</Mui.Button>
					</Mui.Grid>
				</Mui.Grid>
			</FullPageCard>
		);
	}
}

export const WixLandingPage = withStyles(Component, styles);
